<template>

    <div class="f-item" v-if="!(type=='see' && !fieldModel)">
        <van-field
                v-model="fieldModel"
                name="fieldModel"
                autocomplete="off"
                :placeholder="'请选择'+label"
                left-icon="search"
                readonly
                @click="onShowField"
        />
        <div class="clear-search-item" @click="clearFieldModel" v-if="fieldModel">
            <van-icon name="close"/>
        </div>
        <van-popup v-model="popShow" position="bottom" class="vradio">
            <van-radio-group v-model="radioVal">
                <van-cell clickable @click="toggle(item)" v-for="item in lists">
                    <template #right-icon>
                        <van-radio v-if="sdata =='segment'" :name="item.VALUE">{{ item.LABEL_NAME}}</van-radio>
                        <van-radio v-if="sdata =='location'" :name="item.ACTUAL_LOCATION">{{ item.ACTUAL_LOCATION }}</van-radio>
                    </template>
                </van-cell>
            </van-radio-group>
        </van-popup>
    </div>
</template>

<script>
    import common from '@/api/common';

    export default {
        name: "radio",
        props: {
            sdata: String,
            label: String,
            type: String,
            required: Boolean,
            sVal: String
        },
        data() {
            return {
                lists: [], // 原始数据
                listsLabel: [],
                fieldModel: '', // 用于在输入框显示 label的值
                radioVal:'',    // 单选的值
                popShow: false,
            }
        },
        watch: {
            sVal() {
                if (this.$props.sVal) {
                    this.fieldModel = this.$props.sVal
                }
            }
        },
        mounted() {
            this.initData()
        },
        methods: {
            initData(){
                try{
                    // console.log("initData")
                    if (this.$props.sdata == 'appointmentType') {
                        this.lists = JSON.parse(localStorage.getItem('FIND_DIC_INFO_FAE')).APPOINTMENT_TYPE;
                    } else if (this.$props.sdata == 'emergencyLevel') {
                        this.lists = JSON.parse(localStorage.getItem('FIND_DIC_INFO_FAE')).EMERGENCY_LEVEL;
                    }else if (this.$props.sdata == 'segment') {
                        this.lists = JSON.parse(localStorage.getItem('FIND_DIC_INFO_FAE')).SEGMENT;
                    }else if (this.$props.sdata == 'location') {
                        this.lists = JSON.parse(localStorage.getItem('FAE_LOCATION'));
                    }
                    this.listsLabel = this.getLableArr(this.lists);
                }catch (e) {

                }
            },
            onShowField() {
                this.popShow = true;
            },
            clearFieldModel() {
                this.popShow = false;
                this.fieldModel = '';
                this.radioVal ='';
                let data ={
                    name:'',
                    id:''
                }
                this.$emit('onCancel', data)
            },
            toggle(item) {
                this.popShow = false;
                this.fieldModel = item.LABEL_NAME ||item.ACTUAL_LOCATION;
                this.vradioVal = item.VALUE ||item.ACTUAL_LOCATION;
                let data ={
                    name:item.LABEL_NAME  ||item.ACTUAL_LOCATION,
                    id:item.VALUE ||item.ACTUAL_LOCATION
                }
                this.$emit("confirm", data)
            },
        }
    }
</script>

<style scoped lang="less">
    .f-item {
        .van-cell {
            font-size: 14px;
            padding: 10px 16px;
        }

        /deep/ .van-field__control {
            font-size: 14px;
        }

        /deep/ textarea.van-field__control {
            min-height: 68px;
        }

        .clear-search-item {
            position: absolute;
            right: 0;
            top: 0;
            z-index: 1;
            width: 28px;
            height: 34px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #ccc;
            background: #fff;
        }

        .vradio{
            .van-cell__title{
                flex: 1;
            }
        }

        .van-popup {

            .segment-btn {
                //position: absolute;
                //width: 100%;
                //box-sizing: border-box;
                //z-index: 1;
                //top: 0;
                //left: 0;
                padding: 0 15px;
                height: 40px;
                background: #eee;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            /deep/ .van-radio {
                position: relative;
                width: 100%;
                padding: 0 10px;
                box-sizing: border-box;

                .van-radio__label {
                    margin-left: 0;
                }

                .van-radio__icon {
                    position: absolute;
                    right: 0
                }


            }
        }
        /deep/ .van-radio-group{
            max-height: 320px;
            overflow-y: auto;
        }

    }

</style>